import * as React from "react";
import "../../css/Reticle.css";

export interface IReticleProps {}

export function Reticle(props: IReticleProps) {
  return <div className="reticle"></div>;
}
